import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  position: relative;
`;

export const Bar = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 5px;
  width: 200px;
  height: 600px;
`;

export const Preview = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 300px;
  height: 200px;
  z-index: 100;
  display: flex;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  background-color: black;
  border: 1px solid #223;
`;

export const Prompt = styled.div`
  position: absolute;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  width: 800px;
`;
